/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useEffect, useState } from 'react'
import { Button, Checkbox, BaseInput, Text } from '../../atoms'
import * as styles from './index.styles'

const validateEmail = (mail: string) =>
  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)
type Props = { onLogin: (email: string, password: string) => void }

const FormLogin: React.FC<Props> = ({ onLogin }) => {
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [isEmailValid, setIsEmailValid] = useState<boolean>(false)
  const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false)
  const [rememberMe, setRememberMe] = useState<boolean>(false)
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)

  useEffect(() => {
    setIsPasswordValid(password.length > 4)
  }, [password])
  useEffect(() => {
    setIsEmailValid(validateEmail(email))
  }, [email])
  useEffect(() => {
    isFirstRender && setIsFirstRender(false)
  }, [isFirstRender])
  return (
    <div css={styles.container}>
      <img
        src="/logo.png"
        alt="logo"
        css={{ marginBottom: '46px', width: 'inherit' }}
      />
      <div css={{ marginBottom: 59 }}>
        <Text textType="h3" weight="black">
          Ingreso
        </Text>
      </div>
      <BaseInput
        placeholder="Email"
        name="email"
        value={email}
        onChange={(value) => setEmail(value)}
        error={!isEmailValid && email.length > 0}
        success={isEmailValid}
        style={css({ marginBottom: 40 })}
      />
      <BaseInput
        placeholder="Password"
        name="password"
        type="password"
        value={password}
        onChange={(value) => setPassword(value)}
        error={!isPasswordValid && password.length > 0}
        success={isPasswordValid}
        style={css({ marginBottom: 29 })}
      />
      <div css={{ marginBottom: 36, alignSelf: 'start' }}>
        <Checkbox checked={rememberMe} onChange={setRememberMe}>
          Recuerdame
        </Checkbox>
      </div>
      <div css={{ marginBottom: 25,width: '100%' }}>
        <Button
          disabled={!isEmailValid || !isPasswordValid}
          onClick={() => onLogin(email, password)}
        >
          Ingresar
        </Button>
      </div>
       {/* <div css={{ marginBottom: 91, color: '#34189A'}}>
            <Text textType='sm'>¿Olvidaste tu contraseña?</Text>
        </div>*/}
    </div>
  )
}

export default FormLogin
